export default __webpack_public_path__ + "static/media/vivo_two.4286ab57.webp";